function AddUserIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 26 26"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M14.576 13a3.332 3.332 0 003.333-3.333 3.332 3.332 0 10-6.666 0A3.332 3.332 0 0014.575 13zm-7.5-1.667v-2.5H5.409v2.5h-2.5V13h2.5v2.5h1.667V13h2.5v-1.667h-2.5zm7.5 3.334c-2.225 0-6.667 1.116-6.667 3.333v1.667h13.334V18c0-2.217-4.442-3.333-6.667-3.333z" />
    </svg>
  )
}

export default AddUserIcon
